module.exports = __webpack_public_path__ + "static/media/PM65.dc1e2767.png";